import React, { useState } from 'react'
import { Button, Row, Col, Table} from "react-bootstrap"
import { withTranslation } from 'react-i18next';
import { BsFillTrashFill } from 'react-icons/bs';
import Delete from '../../api/Delete';
import { ESTUDIO_IMAGEN_DELETE } from '../../api/Routes';
import ComponentModalErrorSever from '../ComponentModalErrorSever';
import ModalEstudioImagenCatalogo from './ModalEstudioImagenCatalogo';
import {canEditDoctor} from "../../utils/isDoctor";

function DoctorEstudioImagenColombia({ t, citaID, auth, estudiosImagenelogicos, readOnly, cita }){
    const [show, setShow] = useState(false);
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)
    const [estudios, setEstudios] = useState(estudiosImagenelogicos)

    const deleteObj = (id) =>{
        Delete({url: `${ESTUDIO_IMAGEN_DELETE}/${id}`, access_token: auth.data.access_token})
        .then(response=>{
            if(response.data.data.data){
                let arr = estudios.filter(el=>el.id!==id)
                setEstudios(arr)
            }
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return (
        <div className="p-3 pt-4 position-relative">
            <ComponentModalErrorSever
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
            <ModalEstudioImagenCatalogo
                citaID={citaID}
                show={show}
                setItems={setEstudios}
                setShow={setShow}
                auth={auth}
                setShowModalError={setShowModalError}
                setErrorServer={setErrorServer}
            />
            {!readOnly && canEditDoctor(cita, auth) && <Row className="mt-3">
                <Col>
                    <Button onClick={e=>setShow(true)} variant="outline-primary" size="sm">{t('agregar')} </Button>
                </Col>
            </Row>}
            <Row className="mt-3">
                <Col>
                    <Table size="sm">
                        <thead>
                            <tr>
                                <th>{t('estudios_imagenologicos')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                estudios.length === 0 ? 
                                <tr><td>{t('lista_vacia')}</td></tr> :
                                estudios.map((item,i)=>(
                                    <tr key={i}>
                                        <td>{item.nombre}</td>
                                        <td width="5%">{!readOnly && canEditDoctor(cita, auth) && <Button type="button" variant="outline-danger" size="sm" className="py-0 px-1" onClick={e=>deleteObj(item.id)}><BsFillTrashFill /></Button>}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>

        </div>
    )
}

export default withTranslation()(DoctorEstudioImagenColombia)